<div class="backoffice-edit-company-container">
  <div class="title">
    {{ "backoffice.company.modal-edit.title" | translate }}
  </div>
  <div class="form" *ngIf="ready">
    <div class="title-section">
      {{ "backoffice.company.modal-edit.general-section-title" | translate }}
    </div>
    <form [formGroup]="editCompanyForm">
      <div class="section-form">
        <cowing-input
          [inputStyle]="EInputStyleType.Secondary"
          [isForm]="true"
          [placeholder]="'coworking.general.company-name' | translate"
          [label]="'coworking.general.company-name' | translate"
          [control]="editCompanyForm.get('company_name')"
        >
        </cowing-input>
      </div>
      <div class="section-form">
        <div class="dropdown">
          <cowing-input-dropdown
            [inputStyle]="EInputStyleType.Secondary"
            [isForm]="true"
            [label]="'coworking.general.is-business-group' | translate"
            [control]="editCompanyForm.get('is_business_group')"
            [options]="[
              'coworking.general.yes' | translate,
              'coworking.general.no' | translate
            ]"
          >
          </cowing-input-dropdown>
        </div>

        <cowing-input
          [inputStyle]="EInputStyleType.Secondary"
          [isForm]="true"
          [placeholder]="'coworking.general.company-name' | translate"
          [label]="'coworking.general.company-name' | translate"
          [control]="editCompanyForm.get('business_group')"
        >
        </cowing-input>
      </div>

      <cowing-input-location
        [inputStyle]="EInputStyleType.Secondary"
        [isForm]="true"
        [placeholder]="'coworking.general.address' | translate"
        [label]="'coworking.general.address' | translate"
        [control]="editCompanyForm.get('fiscal_address')"
        (setLocation)="setLocation($event)"
      >
      </cowing-input-location>

      <div class="section-form">
        <cowing-input
          [inputStyle]="EInputStyleType.Secondary"
          [isForm]="true"
          [placeholder]="'coworking.general.name' | translate"
          [label]="'coworking.general.name' | translate"
          [control]="editCompanyForm.get('name')"
        >
        </cowing-input>
        <cowing-input
          [inputStyle]="EInputStyleType.Secondary"
          [isForm]="true"
          [placeholder]="'coworking.general.phone' | translate"
          [label]="'coworking.general.phone' | translate"
          [control]="editCompanyForm.get('phone')"
        >
        </cowing-input>
      </div>

      <div class="section-form">
        <cowing-input
          [inputStyle]="EInputStyleType.Secondary"
          [isForm]="true"
          [placeholder]="'coworking.general.tax-id' | translate"
          [label]="'coworking.general.tax-id' | translate"
          [control]="editCompanyForm.get('tax_id')"
        >
        </cowing-input>
        <cowing-input
          [inputStyle]="EInputStyleType.Secondary"
          [isForm]="true"
          [placeholder]="'coworking.general.total-cowings' | translate"
          [label]="'coworking.general.total-cowings' | translate"
          [control]="editCompanyForm.get('total_cowings')"
        >
        </cowing-input>
      </div>
      <div class="section-form">
        <cowing-input
          [inputStyle]="EInputStyleType.Secondary"
          [isForm]="true"
          [placeholder]="'coworking.general.email' | translate"
          [label]="'coworking.general.email' | translate"
          [control]="editCompanyForm.get('email')"
        >
        </cowing-input>
      </div>
    </form>
    <div *ngIf="decodedPayment">
      <div class="title-section">
        {{ "backoffice.company.modal-edit.payment-section-title" | translate }}
      </div>
      <div class="section-form-payment" [formGroup]="paymentCompanyForm">
        <cowing-input
          *ngFor="let control of paymentCompanyForm.controls | keyvalue"
          [inputStyle]="EInputStyleType.Secondary"
          [isForm]="true"
          [placeholder]="control.key"
          [label]="control.key"
          [control]="control.value"
        >
        </cowing-input>
      </div>
    </div>
  </div>
  <div class="footer">
    <cowing-button
      [disabled]="editCompanyForm.invalid"
      [label]="'Guardar'"
      [type]="EButtonType.Rounded"
      [iconShow]="false"
      (event)="editCompany()"
    >
    </cowing-button>
  </div>
</div>
